import { gql } from "@apollo/client";





export const GET_LEAVETYPES_COUNT = gql`
  query LeavesTypesCount($employeeId: String, $orgId: Int) {
    leavesTypesCount(employeeId: $employeeId, orgId: $orgId) {
      leaveType
      maxLeaves
      usedLeaves
      leavetypeId
    }
  }
`;




export const GET_LEAVE_BY_STATUS = gql`
  query leaveByStatus($status: String!, $reportTo: String) {
    leaveByStatus(status: $status, reportTo: $reportTo) {
      Id
      employeeId
      leaveType
      startDate
      endDate
      reason
      reportTo
      orgId
      employeeDetails {
        firstName
        lastName
      }
      status
      totalLeaves
      consumedLeaves
      lop
      leavetypeId
      uploadDocument
    }
  }
`;














export const CREATE_LEAVE_TYPE = gql`
  mutation createLeaveType($input: createLeaveTypeInput) {
    createLeaveType(input: $input) {
      orgId
    }
  }
`;

export const GET_LEAVE_TYPES_BY_ORG = gql`
  query getleaveTypesByOrg($orgId: Int) {
    getleaveTypesByOrg(orgId: $orgId) {
      orgId
      leavetypes
      leavetypevalues
      Id
      leavecarryForward
      leaveMaxLimit
      documentcarryForward
      leaveHistory
      userId
      userDetails {
        firstName
        lastName
      }
    }
  }
`;

export const UPDATE_LEAVE_TYPE = gql`
  mutation updateLeaveType($input: updateLeaveTypeInput) {
    updateLeaveType(input: $input)
  }
`;

export const DELETE_LEAVE_TYPE = gql`
  mutation deleteLeaveType($Id: Int) {
    deleteLeaveType(Id: $Id)
  }
`;

export const UPDATE_EACH_LEAVE_TYPE = gql`
  mutation updateEachLeaveType($input: updateEachLeaveTypeInput) {
    updateEachLeaveType(input: $input)
  }
`;





export const GET_EMPLOYEE__ALL_LEAVES_COUNT = gql`
  query getAllEmployeeLeavesData($employeeId: String, $orgId: Int) {
    getAllEmployeeLeavesData(employeeId: $employeeId, orgId: $orgId) {
      employeeId
      leavetypeId
      leaveType
      totalLeaves
      leavescaryforward
      empleavesdata {
        employeeId
        usedLeaves
        maxLeaves
      }
    }
  }
`;


